<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.35944 11.547L3.06244 8.25C2.92711 8.11467 2.76561 8.073 2.57794 8.125C2.39028 8.177 2.27311 8.29417 2.22644 8.4765C2.17978 8.65883 2.22411 8.82283 2.35944 8.9685L6.35944 12.9685L14.3594 4.9685C14.4531 4.86417 14.4974 4.74433 14.4924 4.609C14.4874 4.47367 14.4353 4.3565 14.3359 4.2575C14.2366 4.1585 14.1219 4.109 13.9919 4.109C13.8619 4.109 13.7448 4.15583 13.6404 4.2495L6.35944 11.547Z"
            fill="currentColor"
        />
    </svg>
</template>
